if (!customElements.get('m240-reviews')) {
  customElements.define('m240-reviews', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      const list = this.querySelector('[data-m240-review-list]');
      const cards = [...this.querySelectorAll('[data-m240-review-card]')];
      const form = this.querySelector('.m240-reviews__form-wrap');
      const dialog = this.querySelector('dialog');
      let count = 16;
      let ordered = [...cards];
      let photoLinks = [];
      let photoIndex = 0;
      const showPhoto = () => {
        dialog.querySelector('img').src = photoLinks[photoIndex].href;
        const counter = dialog.querySelector('[data-photo-count]');
        if (counter) counter.textContent = `${photoIndex + 1} / ${photoLinks.length}`;
      };
      const more = this.querySelector('[data-review-show-more]');
      const update = () => {
        if (list) {
          const columns = innerWidth >= 1024 ? 4 : innerWidth >= 768 ? 3 : 2;
          const fragment = document.createDocumentFragment();
          for (let column = 0; column < columns; column++) {
            const wrapper = document.createElement('div');
            wrapper.className = 'm240-reviews__column';
            for (const [index, card] of ordered.slice(0, count).entries()) { if (index % columns !== column) continue; card.hidden = false; wrapper.appendChild(card); }
            fragment.appendChild(wrapper);
          }
          for (const card of ordered.slice(count)) { card.hidden = true; fragment.appendChild(card); }
          list.replaceChildren(fragment);
          list.classList.add('m240-reviews__grid--enhanced');
        }
        if (more) more.hidden = count >= cards.length;
        for (const card of ordered) {
          if (card.hidden) continue;
          const body = card.querySelector('.m240-review-card__body');
          const button = card.querySelector('[data-m240-review-more]');
          if (button.getAttribute('aria-expanded') === 'true') continue;
          if (!body.dataset.fullText) body.dataset.fullText = body.innerText;
          const full = body.dataset.fullText;
          button.hidden = full.length <= 150;
          body.textContent = full.length > 150 ? full.slice(0, 150).trimEnd() + '...' : full;
        }
      };
      for (const link of this.querySelectorAll('[data-review-write]')) link.addEventListener('click', () => { form.open = true; }, options);
      if (this.querySelector('[data-review-result]')) form.open = true;
      for (const button of this.querySelectorAll('[data-m240-review-more]')) button.addEventListener('click', () => {
        const expanded = button.getAttribute('aria-expanded') !== 'true';
        button.setAttribute('aria-expanded', String(expanded));
        const body = button.previousElementSibling;
        body.textContent = expanded ? body.dataset.fullText : body.dataset.fullText.slice(0, 150).trimEnd() + '...';
        button.textContent = expanded ? this.dataset.readLess : this.dataset.readMore;
      }, options);
      this.querySelector('[data-m240-review-sort]')?.addEventListener('change', event => {
        const mode = event.target.value;
        const number = (card, key) => Number(card.dataset[key]) || 0;
        const sorted = [...cards].sort((a, b) => {
          if (mode === 'latest') return number(b, 'date') - number(a, 'date');
          if (mode === 'oldest') return number(a, 'date') - number(b, 'date');
          if (mode === 'highest') return number(b, 'rating') - number(a, 'rating');
          if (mode === 'lowest') return number(a, 'rating') - number(b, 'rating');
          if (mode === 'helpful') return number(b, 'helpful') - number(a, 'helpful');
          return number(a, 'order') - number(b, 'order');
        });
        ordered = sorted;
        update();
      }, options);
      more?.addEventListener('click', () => { count += 16; update(); }, options);
      for (const link of this.querySelectorAll('[data-review-photo]')) link.addEventListener('click', event => {
        if (!dialog.showModal) return;
        event.preventDefault();
        const card = link.closest('[data-m240-review-card]');
        photoLinks = [...(card || this.querySelector('.m240-reviews__photos')).querySelectorAll('[data-review-photo]')];
        photoIndex = photoLinks.indexOf(link);
        showPhoto();
        dialog.showModal();
      }, options);
      dialog.querySelector('[data-photo-prev]')?.addEventListener('click', () => { photoIndex = (photoIndex - 1 + photoLinks.length) % photoLinks.length; showPhoto(); }, options);
      dialog.querySelector('[data-photo-next]')?.addEventListener('click', () => { photoIndex = (photoIndex + 1) % photoLinks.length; showPhoto(); }, options);
      for (const button of this.querySelectorAll('[data-review-helpful]')) {
        const key = `m240-review-vote-${button.closest('[data-review-id]').dataset.reviewId}`;
        try { button.setAttribute('aria-pressed', String(localStorage.getItem(key) === '1')); } catch {}
        button.addEventListener('click', () => {
          const selected = button.getAttribute('aria-pressed') !== 'true';
          button.setAttribute('aria-pressed', String(selected));
          try { localStorage.setItem(key, selected ? '1' : '0'); } catch {}
          let status = button.parentElement.querySelector('[role="status"]');
          if (!status) { status = document.createElement('span'); status.setAttribute('role', 'status'); status.className = 'visually-hidden'; button.parentElement.appendChild(status); }
          status.textContent = selected ? 'Your vote is saved on this device.' : 'Your vote was removed from this device.';
        }, options);
      }
      dialog.addEventListener('click', event => { if (event.target === dialog) dialog.close(); }, options);
      window.addEventListener('resize', update, options);
      update();
      document.fonts.ready.then(() => { if (this.isConnected) update(); });
    }
    disconnectedCallback() { this.controller?.abort(); }
  });
}
